import React from 'react';

interface PolygonInstructionsProps {
  pointCount: number;
}

export const PolygonInstructions: React.FC<PolygonInstructionsProps> = ({ pointCount }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: '100px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10001,
        backgroundColor: 'rgba(30, 64, 175, 0.95)',
        color: 'white',
        padding: '1rem 1.5rem',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        maxWidth: '500px',
        animation: 'fadeIn 0.3s ease-in-out'
      }}
    >
      <div style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#60a5fa',
        minWidth: '40px',
        textAlign: 'center'
      }}>
        {pointCount}
      </div>
      <div>
        <div style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>
          {pointCount < 3
            ? `${3 - pointCount} nokta daha ekleyin`
            : 'Çokgen hazır!'}
        </div>
        <div style={{ fontSize: '0.75rem', opacity: 0.9 }}>
          <strong>Sol tık:</strong> Nokta ekle • <strong>Sağ tık:</strong> Tamamla • <strong>ESC:</strong> İptal
        </div>
      </div>
    </div>
  );
};
